<template>
  <div class="usageHistoryTableRoot">
    <div class="tableMenu">
      <b-select
        placeholder="レポートの種類"
        icon="file"
        icon-pack="fas">
        <option value="all">すべて</option>
      </b-select>
      <date-range @search="handleOnSearch" title="" class="dateRange"/>
    </div>
    <b-table
      :data="data"
      sortable
      style="padding-top: 16px;"
      hoverable
      default-sort-direction="desc"
      default-sort="operatedAt">

      <template slot-scope="props">
        <b-table-column field="operatedAt" label="操作日時" sortable>
          {{ props.row.operatedAt }}
        </b-table-column>

        <b-table-column field="reportName" label="レポート" sortable>
          {{ props.row.reportName }}
        </b-table-column>

        <b-table-column field="displayName" label="グループ" sortable>
          {{ props.row.group }}
        </b-table-column>

        <b-table-column field="displayName" label="テンプレート名" sortable>
          {{ props.row.displayName }}
        </b-table-column>

        <b-table-column field="result" label="結果" sortable>
          {{ props.row.result }}
        </b-table-column>
        
        <b-table-column field="processTime" label="処理時間" sortable>
          {{ props.row.processTime }}
        </b-table-column>

        <b-table-column field="size" label="データサイズ" sortable>
          {{ props.row.size }}
        </b-table-column>

      </template>

      <template slot="empty">
        <b-message type="is-info" has-icon>
          条件に合致する結果はありませんでした。
        </b-message>
      </template>
      
    </b-table>
  </div>
</template>

<script >
import Vue from "vue";
import DateRange from "@/components/molecules/DateRange/index.vue";

export default Vue.extend({
  components: { DateRange },
  data() {
    return {
      rows: [],
    };
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    nextToken: {
      type: String,
    },
    QueryExecutionId: {
      type: String,
    },
  },
  methods: {
    handleOnPaginationChange(nextPage) {
      // TODO
      // Get next items from Server
      // this.$emit('getNextUsageHistory');
    },
    handleOnSearch(val) {
      this.$emit("search", val);
    },
  },

});
</script>

<style lang="scss" scoped>
.usageHistoryTableRoot {
  & .tableMenu {
    @media screen and (min-width: 1024px) {
      display: flex;
    }
  }
  & .dateRange {
    margin-left: 16px;

    @media screen and (max-width: 768px) {
      margin: 16px 0px;
    }
  }
}
</style>
